import { Component } from '@angular/core';
import { CoreSignalCourseEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Courses') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalcourse-form',
    templateUrl: './coresignalcourse.form.component.html'
})
export class CoreSignalCourseFormComponent extends BaseFormComponent {
    public record!: CoreSignalCourseEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

